module.exports = __webpack_public_path__ + "media/images/icon_sort_btn_favorite-886cf07bffe620edb3828479977e0038.png";